// src/pages/PrivacyPolicy.jsx
export default function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow">
                <h1 className="text-3xl font-bold mb-4 text-gray-800">
                    Privacy Policy
                </h1>

                <p className="text-sm text-gray-500 mb-6">
                    Effective Date: January 2026
                </p>

                <p className="mb-4 text-gray-700">
                    MyBioTick (“we”, “our”, “us”) is a personal management application
                    designed to help users securely store Personal records
                    information.
                    This Privacy Policy explains how we collect, use, store, and protect
                    your information.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    1. Information We Collect
                </h2>

                <p className="mb-2 text-gray-700">
                    Depending on how you use the app, we may collect the following information:
                </p>

                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>
                        <strong>Account Information:</strong> Name, email address, and unique
                        account identifiers used for authentication.
                    </li>
                    <li>
                        <strong>Personal Data:</strong> Personal reports, prescriptions,
                        test results, diagnoses, visit history, and other related
                        information voluntarily uploaded by the user.
                    </li>
                    <li>
                        <strong>Device & App Data:</strong> Basic device information required
                        for app functionality, security, and error prevention.
                    </li>
                </ul>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    2. How We Use Your Information
                </h2>

                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>To securely store and organize your Personal records</li>
                    <li>To maintain app security and reliability</li>
                    <li>To comply with legal and regulatory requirements</li>
                </ul>

                <p className="mt-2 text-gray-700">
                    We do <strong>not</strong> use your data for advertising, marketing,
                    profiling, or selling to third parties.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    3. Google API Usage (If Applicable)
                </h2>

                <p className="text-gray-700 mb-2">
                    If Google services are used, we access only the minimum required scopes
                    for authentication or calendar-based appointment management.
                </p>

                <code className="block bg-gray-100 p-3 rounded text-sm">
                    https://www.googleapis.com/auth/calendar.events
                </code>

                <p className="mt-2 text-gray-700">
                    Google user data is handled in compliance with the
                    <strong> Google API Services User Data Policy</strong>.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    4. Data Storage & Security
                </h2>

                <p className="text-gray-700">
                    We use industry-standard security measures including encryption,
                    access controls, and secure servers to protect your data.
                    Access to sensitive data is strictly limited.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    5. Data Retention & Deletion
                </h2>

                <p className="text-gray-700">
                    You may request account deletion at any time. Upon deletion,
                    all personal and Personal data associated with your account
                    will be permanently removed, unless retention is required by law.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    6. Your Rights
                </h2>

                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>Access and review your data</li>
                    <li>Update or correct your information</li>
                    <li>Request deletion of your account and data</li>
                </ul>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    7. Contact Information
                </h2>

                <p className="text-gray-700">
                    If you have any questions about this Privacy Policy, contact us at:
                </p>

                <p className="text-gray-700 mt-2">
                    <strong>Email:</strong> naveen011214@gmail.com
                </p>
            </div>
        </div>
    );
}
